export default __webpack_public_path__ + "static/arrow-green-ce40fdb93a1854acc711a815b1c292af.png";